import React, { useEffect } from 'react';
import Backdrop from '../../Backdrop/Backdrop';
import styled from 'styled-components';
import { enableScroll, disableScroll } from '../../../utils/enable-disable-scroll';
import { screenWidths } from '../../../enums';

const SideDrawerContainer = styled.aside<{ media: keyof typeof screenWidths }>`
	position: fixed;
	padding-top: 71px;
	width: 300px;
	flex-shrink: 0;
	height: 100vh;
	left: 0;
	top: 0;
	z-index: 400;
	background-color: ${({ theme }) => theme.NAV_BG};
	box-sizing: border-box;
	transition: all 0.3s ease-in-out;
	overflow-y: auto;
	direction: rtl;
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
		width: 6px;
		height: 6px;
	}

	::-webkit-scrollbar-thumb {
		background-color: #888;
		/* outline: 1px solid #575757; */
		/* opacity: 0.2; */
	}

	&.open {
		left: 0;
	}

	&.closed {
		left: -100%;
	}

	&.not-collapsed {
	}

	.sidedrawer-children {
		z-index: 2000;
		direction: ltr;
	}

	@media (min-width: ${({ media }) => screenWidths[media]}) {
		width: 80px;
		z-index: 200;
		&.closed {
			left: 0;
		}
		&.not-collapsed {
			width: 220px;
		}
	}
`;

const SideDrawer = ({ visible, onClose, collapsable, onCollapse, collapsed, children, media }) => {
	useEffect(() => {
		if (visible) disableScroll();
		else enableScroll();
	}, [visible]);
	return (
		<SideDrawerContainer
			className={[visible ? 'open' : 'closed', collapsed ? null : 'not-collapsed'].join(' ')}
			media={media}
			onMouseEnter={() => onCollapse(false)}
			onMouseLeave={() => onCollapse(true)}
		>
			<Backdrop show={visible} clicked={onClose} media={media} />
			<div className="sidedrawer-children">{children}</div>
			{/* {collapsable ? <SideDrawerToggle collapsed={collapsed} /> : null} */}
		</SideDrawerContainer>
	);
};

export default SideDrawer;
